module.exports = __webpack_public_path__ + "img/Makefile.999a0091.png";